// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PaymentPlanInstalmentDTO
 */
export interface PaymentPlanInstalmentDTO {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    paymentPlanId: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlanInstalmentDTO
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    dueDate: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlanInstalmentDTO
     */
    instalmentNumber: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    completedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    manualPaymentDeadline: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    attemptedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    status: PaymentPlanInstalmentDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanInstalmentDTO
     */
    source?: PaymentPlanInstalmentDTOSourceEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentPlanInstalmentDTOStatusEnum {
    PENDING = 'PENDING',
    PAID = 'PAID',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentPlanInstalmentDTOSourceEnum {
    REFUND = 'REFUND',
    STRIPEDISPUTE = 'STRIPE_DISPUTE',
    FAILEDPAYMENTRESCHEDULE = 'FAILED_PAYMENT_RESCHEDULE',
    PENDINGINSTALMENTRESCHEDULE = 'PENDING_INSTALMENT_RESCHEDULE',
    INSTALMENTDESIGNER = 'INSTALMENT_DESIGNER'
}



